import type { Schemas } from "@/api/client";
import {
  Activity,
  BarChart3,
  FolderKanban,
  LayoutDashboard,
  ListTodo,
  Network,
  Palette,
  Palmtree,
  Settings,
  Table2,
  Users,
  type LucideIcon,
} from "lucide-react";

export type NavKey =
  | "dashboard"
  | "activity"
  | "timesheets"
  | "projects"
  | "myTasks"
  | "reports"
  | "timeOff"
  | "people"
  | "teams"
  | "settings"
  | "designSystem";

export type NavItem = {
  key: NavKey;
  path: string;
  icon: LucideIcon;
  group: "main" | "manage" | "dev";
  /** Roadmap stage that delivers the section; undefined = available now. */
  stage?: number;
  /** Shown only with this permission (the server checks access anyway). */
  permission?: keyof Schemas["Permissions"];
};

// Stages follow docs/10-roadmap.md.
export const navItems: NavItem[] = [
  { key: "dashboard", path: "/", icon: LayoutDashboard, group: "main" },
  { key: "activity", path: "/activity", icon: Activity, group: "main" },
  { key: "timesheets", path: "/timesheets", icon: Table2, group: "main" },
  { key: "projects", path: "/projects", icon: FolderKanban, group: "main" },
  { key: "myTasks", path: "/tasks", icon: ListTodo, group: "main" },
  { key: "reports", path: "/reports", icon: BarChart3, group: "main" },
  { key: "timeOff", path: "/time-off", icon: Palmtree, group: "main" },
  { key: "people", path: "/people", icon: Users, group: "manage", permission: "view_team" },
  { key: "teams", path: "/teams", icon: Network, group: "manage", permission: "view_team" },
  { key: "settings", path: "/settings", icon: Settings, group: "manage" },
  ...(import.meta.env.DEV
    ? [{ key: "designSystem", path: "/design-system", icon: Palette, group: "dev" } satisfies NavItem]
    : []),
];
